import { useState } from "react";
import { Ban, RotateCcw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Avatar, Empty, RoleBadge, RoleSelect, StatusBadge, fmtDate } from "./TeamBits";

const MAIN_ADMIN = "jaikhande.godinga@gmail.com";
const FILTERS = [
  { id: "all", label: "All" },
  { id: "approved", label: "Active" },
  { id: "suspended", label: "Suspended" },
  { id: "rejected", label: "Rejected" },
];

function MemberRow({ u, onAct }) {
  const { user } = useAuth();
  const locked = u.user_id === user?.user_id || u.email?.toLowerCase() === MAIN_ADMIN || (u.role === "super_admin" && user?.role !== "super_admin");
  return (
    <div data-testid={`member-${u.user_id}`} className="flex flex-wrap items-center gap-4 rounded-2xl border border-border bg-card p-4">
      <Avatar u={u} />
      <div className="min-w-0 flex-1">
        <p className="flex flex-wrap items-center gap-2 font-semibold">{u.name || "—"} <RoleBadge role={u.role} />{u.user_id === user?.user_id && <span className="text-xs font-normal text-muted-foreground">(you)</span>}</p>
        <p className="truncate text-sm text-muted-foreground">{u.email}</p>
        <p className="mt-0.5 text-xs text-muted-foreground">Last login {fmtDate(u.last_login_at)}{u.approved_by ? ` · approved by ${u.approved_by}` : ""}</p>
      </div>
      <StatusBadge status={u.status} testId={`member-status-${u.user_id}`} />
      {!locked && (
        <div className="flex flex-wrap gap-2">
          {u.status === "approved" && <RoleSelect value={u.role} onChange={(r) => onAct(u, "role", r)} testId={`member-role-${u.user_id}`} />}
          {u.status === "approved" ? (
            <button onClick={() => onAct(u, "suspend")} data-testid={`suspend-${u.user_id}`} className="inline-flex items-center gap-1 rounded-xl border border-border px-3 py-2 text-sm font-semibold text-destructive transition-colors hover:bg-destructive/10">
              <Ban className="h-4 w-4" /> Suspend
            </button>
          ) : (
            <button onClick={() => onAct(u, "approve", u.role)} data-testid={`reactivate-${u.user_id}`} className="inline-flex items-center gap-1 rounded-xl bg-emerald-600 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-700">
              <RotateCcw className="h-4 w-4" /> Reactivate
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export function MembersList({ users, onAct }) {
  const [filter, setFilter] = useState("all");
  const list = users.filter((u) => u.status !== "pending" && (filter === "all" || u.status === filter));
  return (
    <div>
      <div className="mb-4 flex flex-wrap gap-2">
        {FILTERS.map((f) => (
          <button key={f.id} onClick={() => setFilter(f.id)} data-testid={`members-filter-${f.id}`} className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${filter === f.id ? "bg-gold text-primary" : "bg-secondary hover:bg-secondary/70"}`}>{f.label}</button>
        ))}
      </div>
      {list.length ? <div className="space-y-3" data-testid="members-list">{list.map((u) => <MemberRow key={u.user_id} u={u} onAct={onAct} />)}</div> : <Empty>No members here.</Empty>}
    </div>
  );
}
